import axios from '../plugins/axios.js';

export default {
    async get(id, payload = {}) {
        const response = await axios.get('example', { params: payload });

        return response.data.data;
    },

    async show(id, payload = {}) {
        const response = await axios.get(`example/${id}`, { params: payload });

        return response.data.data;
    },

    async update(id, payload = {}) {
        const response = await axios.put(`example/${id}`, payload);

        return response.data.data;
    },

    async delete(id) {
        return axios.delete(`example/${id}`);
    },
};
